








































import Vue from 'vue';
import Component from 'vue-class-component';
import { Getter, Action } from 'vuex-class';
import { Watch } from 'vue-property-decorator';
import { Process } from '@attensi/api-js';

import ProcessVideo from '../../../processVideo/ProcessVideo.vue';
import DragAndDropOverlay from './DragAndDropOverlay.vue';
import ReviewToolbar from './ReviewToolbar.vue';

@Component({ components: { ProcessVideo, DragAndDropOverlay, ReviewToolbar } })
export default class ProcessReview extends Vue {
  @Getter('processModule/reviewProcess') reviewProcess!: Process;

  @Watch('reviewProcess', { deep: true, immediate: true })
  onReviewProcessChanged(newReviwProcess: Process, oldReviewProcess: Process) {
    if (newReviwProcess) {
      this.setActiveProcess(newReviwProcess);
    }
  }

  @Action('processModule/setActiveProcess') setActiveProcess!: Function;
}
